import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';

import { profileOperations } from '../../redux/ducks/profile';

const withProfileData = (WrappedComponent) => {

    const Wrapper = (props) => {
        const dispatch = useDispatch();
        const email = useSelector(({ profile }) => profile.profileState.email);
        const isLoading = useSelector(({ profile }) => profile.loadingState.profileInfo.isLoading);

        useEffect(() => {
            if (!email) {
                dispatch(profileOperations.fetchAccountInfo());
            }
        }, []);

        return (
            <div className="dummy-container">
                <LoadingDisplay isLoading={isLoading}>
                    <WrappedComponent {...props} />
                </LoadingDisplay>
            </div>
        );
    };

    return Wrapper;
};

export default withProfileData;